import { Member } from './member';

export enum GroupType {
  Default = 'default',
  Workshop = 'workshop',
  OneOnOne = 'one-on-one',
  Community = 'community',
  PeerOnMany = 'peer-on-many',
  TrainingPeer = 'training-peer',
  OrganizationStrict = 'organization-strict',
  AudioRoom = 'audio-room',
  GuideCommunity = 'guide-community',
}

export enum GroupStatus {
  Active = 'active',
  Inactive = 'inactive',
  Locked = 'locked',
  Pending = 'pending',
}

export enum GroupCloseReason {
  LowAttendance = 'low_attendance',
  Merged = 'merged',
  MergedSecondCycle = 'merged_second_cycle',
  GfLeft = 'gf_left',
  NaturallyEnded = 'naturally_ended',
  GuideDidNotShowUp = 'guide_did_not_show_up',
}

export enum GroupDisplayType {
  Default = 'default',
  PremiumFacilitator = 'premium_facilitator',
}

export enum GroupScheduleType {
  Recurring = 'recurring',
  OnDemand = 'on_demand',
  ForLater = 'for_later',
}

export type BaseSchedule = {
  minute: number;
  hour: number;
  weekday: number;
};

export type GroupSchedule = BaseSchedule & {
  duration: number;
  local?: BaseSchedule & {
    tz: string;
  };
};

export interface GroupCriterias {
  segment?: string[];
}

export interface GroupMeta {
  revertRescheduleOn?: number;
  weeksDuration?: number;
}

// use for list of groups
export type GroupItem = {
  id: string;
  groupInstanceId: string;
  leaderAccountId: string;
  leaderName: string;
  title: string;
  description: string;
  status: GroupStatus;
  nextStart: number;
  nextEnd: number;
  schedule: GroupSchedule;
  startDate: string;
};

export enum VideoProviders {
  Zoom = 'zoom',
  Twilio = 'twilio',
}

// use for home screen - group space
export type GroupSpaceItem = Pick<GroupItem, 'id' | 'leaderAccountId' | 'schedule' | 'title'> & {
  members: Member[];
  startFrom?: number;
  video?: {
    provider: VideoProviders;
    active: boolean;
    url?: string;
    password?: string;
    regId?: string;
    meetingId?: string;
    hostId?: string;
  };
  payment?: {
    isFree?: boolean;
    planName: string;
    period?: string;
    description?: string;
    cta: string;
    trialDays?: number;
  };
  organizationLogo?: string;
  lastUpdated: number;
  introVideoLink: string;
};

// GBS
export type GroupBelongingSurveyQuestion = {
  maxPointsText?: string;
  minPointsText?: string;
  scale?: number;
  question: string;
  type: string;
};

export type GroupBelongingSurvey = {
  id: string;
  buttonText: string;
  title: string;
  questions: GroupBelongingSurveyQuestion[];
};

export enum GroupSubsegments {
  NarcParent = 'narc_parent',
  NarcPast = 'narc_past',
  NarcOngoing = 'narc_ongoing',
  GriefChild = 'grief_child',
  GriefParent = 'grief_parent',
  GriefSpouse = 'grief_spouse',
  GriefLovedOne = 'grief_loved_one',
  DivorceNoKids = 'divorce_no_kids',
  DivorceKids = 'divorce_kids',
  NarcOther = 'narc_other',
  GriefSuicide = 'grief_suicide',
  Other = 'other',
  DivorceOther = 'divorce_other',
  CaregiverForParent = 'caregiver_for_parent',
  CaregiverSpecialNeeds = 'caregiver_special_needs',
  CaregiverForSpouse = 'caregiver_for_spouse',
  ChronicCondition = 'chronic_condition',
  Disability = 'disability',
  FertilityNeverPregnant = 'fertility_never_pregnant',
  FertilityPregnantBefore = 'fertility_pregnant_before',
  FertilityOther = 'fertility_other',
  Parenting = 'parenting',
  PostpartumNewMom = 'postpartum_new_mom',
  Relocation = 'relocation',
  Seniors = 'seniors',
}
